import apiService from "./apiServices";


export const saveTheme = async (customTheme, user, token) => {
  try {
    if (!user?.customer?.id || !user?.id) {
      throw new Error("Missing user information");
    }
    const formData = new FormData();
    if (customTheme.fileData) {
      formData.append('file', customTheme.fileData);
    }
    formData.append('colour', customTheme?.primaryColor || '#077BFD');
    formData.append('secondaryColor', customTheme?.secondaryColor || '#000000');
    formData.append('font', customTheme?.themeFont || 'default');
    formData.append('customerId', user.customer.id);
    formData.append('userId', user.id);
    formData.append('name', customTheme?.name || 'new theme');

    // Remove /api/v1 from the path
    const response = await apiService('/theme/upload', 'POST', formData, {}, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Saving theme failed. Please try again.');
  }
}

export const updateTheme = async (Id, formData, token) => {
  try {

    const response = await apiService(`/theme/update/${Id}`, 'PUT', formData, null, token);
    return response;
    } catch (error) {
      throw (error?.message || 'Updating theme is failed. Please try again.');
    }
}

export const getThemeById = async (themeId, token) => {
  try {
    const response = await apiService(`/theme/get/${themeId}`, 'GET', null, {}, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Fetching theme failed. Please try again.');
  }
}

export const setDefaultThemeService = async (themeid, token) => {
  try {
    const response = await apiService(`/customer/set/theme/${themeid}`, 'POST',null, {}, token);
    return response;
  } catch (error) {
    throw (error?.message || 'Updating theme is failed. Please try again.');
  }
}

export const getTheme = async (token) => {
  try {    
    const response = await apiService(`/theme/user/get`, 'GET',null, null, token);    
    return response;
  } catch (error) {
    throw (error?.message || 'Fetching theme failed. Please try again.');
  }
}

export const getSelectedThemLogo = async (id, token) => {  
  try {
    
    const response = await apiService(`/theme/logo/get/${id}`, 'GET', null, null, token);    
    return response;
  } catch (error) {
    throw (error?.message || 'Fetching theme failed. Please try again.');
  }
}


export const getAllTheme = async (token) => {
  try {
    
    const response = await apiService(`/theme/customer/themes`, 'GET',null, null, token);    
    return response;
  } catch (error) {
    throw (error?.message || 'Fetching theme failed. Please try again.');
  }
}

export const getUserDomain = async (userId, token) => {
  try {
    return await apiService(`/user-themes/getDomain/${userId}`, 'GET', null, {}, token);
  } catch (error) {
    throw (error?.message || 'Fetching user domain failed.');
  }
};

export const getThemesByDomain = async (domainId, token) => {
  try {
    return await apiService(`/domains/getThemesByDomain/${domainId}`, 'GET', null, {}, token);
  } catch (error) {
    throw (error?.message || 'Fetching themes by domain failed.');
  }
};

export const addThemeToDomain = async (domainId, themeId, token) => {
  try {
    return await apiService(`/domains/addThemeToDomain/${domainId}/${themeId}`, 'POST', null, {}, token);
  } catch (error) {
    throw (error?.message || 'Adding theme to domain failed.');
  }
};


